import { render } from "./ManagerRoster.vue?vue&type=template&id=1c235ab3&scoped=true&ts=true"
import script from "./ManagerRoster.vue?vue&type=script&lang=ts"
export * from "./ManagerRoster.vue?vue&type=script&lang=ts"

import "./ManagerRoster.vue?vue&type=style&index=0&id=1c235ab3&scoped=true&lang=css"

import exportComponent from "/app/src/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1c235ab3"]])

export default __exports__